import React from 'react'
import FilterCheckbox from '../filter-checkbox'
import {get} from 'lodash/fp'
import {renderIf} from '../../lib/util.js'

export default ({clearFilters, filterState, toggleFilterSection, selectFilter, selected, designateLocation, locationsState, inPersonCitiesState }) => {
  return (
    <div id="filters" className="filter col-md-3">
      <h1>Filter By</h1>
      <span onClick={clearFilters} className="btn btn-default" style={{transform: 'scale(0.8)', marginLeft: '-15px'}} >Clear Filters</span>
      {Object.keys(filterState).map((groupName, i) => {
        return(
          <div key={i}>
          {groupName !== 'Location' ? 
          // Filter headings except Location
          <div>
            <h2> {groupName !== 'Courses' ? groupName : 'Course Level'} </h2>
            {Object.keys(filterState[groupName]).map((filterName, i) => {
              let next = filterState[groupName][filterName]
              // COURSE FILTERS
              if(next.courses) {
                return (
                  <div key={i} >
                    <FilterCheckbox
                      category={i}
                      title={filterName}
                      value={filterName}
                      checked={get(`Courses.${filterName}.open`, filterState)} 
                      onChange={toggleFilterSection} />
                    <div className={'filter-list ' + renderIf(!filterState.Courses[filterName].open, 'hide')}>
                      {next.courses.map((course, i) => {
                        // Conditionally render course filters
                        if(selected.has('code') || selected.has('ops')){
                          if(selected.has(course.queryFilterName.split('-')[0])) {
                            return (
                              <FilterCheckbox 
                                key={i}
                                category={i}
                                title={course.displayName}
                                value={course.queryFilterName}
                                checked={selected.has(course.queryFilterName)}
                                onChange={selectFilter}
                                />
                            )
                          }
                        } else {
                            return (
                              <FilterCheckbox 
                                key={i}
                                category={i}
                                title={course.displayName}
                                value={course.queryFilterName}
                                checked={selected.has(course.queryFilterName)}
                                onChange={selectFilter}
                                />
                            )
                          }
                      })}
                    </div>
                  </div>
                )
              } 
            // PROGRAM, START DATE, SCHEDULE
            return (
              <div key={i + 'a'} >  
                <FilterCheckbox 
                  key={i + 'a' }
                  category={i + 'a'}
                  title={next.displayName}
                  value={next.queryFilterName}
                  checked={selected.has(next.queryFilterName)}
                  onChange={selectFilter}
                  />
              </div>
            )
          })}
          </div>
        : 
          // LOCATION
          <div key={i + 'b'} >  
            {designateLocation === true ? 
            // Render LOCATION filter options
            <div>
              <h2> {groupName} </h2>
              {locationsState.map((location, i) => {
                // ONLINE + CITIES
                return (
                  <FilterCheckbox 
                    key={i + 'c' }
                    category={i + 'c'}
                    title={location.displayName}
                    value={location.queryFilterName}
                    checked={selected.has(location.queryFilterName)}
                    onChange={selectFilter}
                    isDisabled={!inPersonCitiesState.includes(location.displayName) ? true : false}
                  />
                )
              })}
            </div>
            : '' 
            }
          </div>
        }
        </div>
        )}
      )}
    </div>
  )
}




// WEBPACK FOOTER //
// ./src/components/course-calendar-filter/index.js